import { Factory } from 'rosie';

Factory.define('SystemConfiguration');

Factory.define('SystemConfigurationWithDefaults').extend('SystemConfiguration').attr('fbAppId', 'some-fb-app-id');
